import { RadioCard, RadioCardGroup } from '@cartwheel/components'

const CLIENT_UNRESPONSIVE = 'client_unresponsive'

const DEFAULT_OPTIONS = [
  {
    value: CLIENT_UNRESPONSIVE,
    label: 'Client unresponsive',
    helper:
      'Logged outreach attempts received no response. Marking the task complete will leave the appointment to auto-cancel per existing timing rules.',
  },
]

export function CannotSendRadio({
  options = DEFAULT_OPTIONS,
  defaultValue = CLIENT_UNRESPONSIVE,
}: {
  options?: Array<{ value: string; label: string; helper?: string }>
  defaultValue?: string
} = {}) {
  return (
    <RadioCardGroup name="cannot-send-outcome" defaultValue={defaultValue} className="space-y-2">
      {options.map((option) => (
        <RadioCard
          key={option.value}
          value={option.value}
          title={option.label}
          subtitle={option.helper}
        />
      ))}
    </RadioCardGroup>
  )
}
